import { colors, IMSelect, Select } from '@insurancemenu/imenu-components-lib';
import SubtitleWithLines from 'components/common/general/SubtitleWithLines';
import styled from 'styled-components';

export const StyledGroupName = styled.b`
  color: ${colors.neutral[900]};
`;

export const FormWrapperStyled = styled.div`
  width: 100%;
`;

export const CurrentAffiliationBlockStyled = styled.div`
  padding-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
  gap: 4rem;
`;

export const DisabledSelectStyled = styled(Select)`
  & select {
    color: ${colors.neutral[900]};
    background-color: ${colors.neutral.white};
  }
`;

export const SubtitleWithLinesStyled = styled(SubtitleWithLines)`
  margin-bottom: 4rem;
`;

export const IMSelectStyled = styled(IMSelect)`
  width: 45%;
  flex: unset;
`;

export const StepBlockStyled = styled.div`
  margin-bottom: 5rem;
  background-color: #ebf0f98f;
  padding: 1rem 2rem 3rem;
  border-radius: 10px;
  box-sizing: border-box;
`;

export const StepHeaderStyled = styled.header`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  margin-top: 0.8rem;
`;

export const StepNumberStyled = styled.span`
  background-color: ${colors.green[600]};
  border-radius: 50%;
  color: ${colors.neutral.white};
  font-size: 1.6rem;
  line-height: 1.8rem;
  font-weight: 700;
  width: 3.2rem;
  height: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StepHeaderTextStyled = styled.h2`
  font-size: 1.8rem;
  line-height: 2.4rem;
`;

export const TargetAgencyBlockStyled = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  box-sizing: border-box;
  gap: 2rem;
`;

export const AorBlockStyled = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  box-sizing: border-box;
`;

export const NoAorsAvailableMessage = styled.p`
  margin: 0;
  text-align: center;
  font-size: 1.6rem;
  font-weight: 400;
  color: ${colors.red[600]};
  line-height: 2rem;
`;
